<template>
  <b-card no-body class="mb-0">

    <!-- 🔹 Üst Filtre Alanı -->
    <div class="m-2">
      <b-row class="justify-content-between">
        <!-- Gösterim Sayısı -->
        <b-col
          cols="12"
          md="4"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <label>Gösterim Sayısı</label>
          <v-select
            v-model="perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="perPageOptions"
            :clearable="false"
            class="per-page-selector d-inline-block mx-50"
          />
          <label>sonuç</label>
        </b-col>

        <!-- Arama -->
        <b-col
          cols="12"
          md="4"
          class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
        >
          <b-input-group class="input-group-merge">
            <b-form-input
              v-model="searchQuery"
              placeholder="Admin, fenomen veya aksiyonda ara..."
              @keyup.enter="refetchData"
            />
            <b-input-group-append>
              <b-button variant="primary" @click="refetchData">Ara</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
    </div>

    <!-- 🔹 Tablo Alanı -->
    <b-table
      ref="refLoggerTable"
      class="position-relative"
      responsive
      :items="fetchLogs"
      :fields="tableColumns"
      :sort-by.sync="sortBy"
      :sort-desc.sync="isSortDirDesc"
      primary-key="id"
      show-empty
      empty-text="Kayıt bulunamadı"
    >
      <template #cell(created_at)="data">
        {{ formatDate(data.item.created_at) }}
      </template>

      <template #cell(success)="data">
        <b-badge :variant="data.item.success == 1 ? 'success' : 'danger'">
          {{ data.item.success == 1 ? 'Başarılı' : 'Hata' }}
        </b-badge>
      </template>

      <template #cell(manager)="data">
        <b v-if="data.item.manager.id">
            <b-badge> {{ data.item.manager.name }} </b-badge>
        </b>
      </template>

      <template #cell(influencer)="data">
        <b v-if="data.item.influencer.id">
            <influencer-link-btn :id="data.item.influencer.id" :name="data.item.influencer.username"/>
        </b>
      </template>

      <template #cell(link)="data">
        <b v-if="data.item.link.id">
          <campaign-link-btn :name="data.item.link.campaign_name" :route="'campaign-detail'" />
          </b>

      </template>

    </b-table>

    <!-- 🔹 Sayfalama -->
    <div class="mx-2 mb-2">
      <b-row>
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
          <span class="text-muted">Toplam {{ total }} kayıt</span>
        </b-col>

        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="total"
            :per-page="perPage"
            align="right"
            @change="refetchData"
          />
        </b-col>
      </b-row>
    </div>

  </b-card>
</template>

<script>
import vSelect from 'vue-select'
import InfluencerLinkBtn from '@/components/link/InfluencerLinkBtn.vue'
import CampaignLinkBtn from '@/components/link/CampaignLinkBtn.vue'
import {
  BCard,
  BRow,
  BCol,
  BTable,
  BPagination,
  BButton,
  BBadge,
  BInputGroup,
  BInputGroupAppend,
  BFormInput,
} from 'bootstrap-vue'

export default {
  name: 'LoggerList',
  components: {
    vSelect,
    BCard,
    BRow,
    BCol,
    BTable,
    BPagination,
    BButton,
    BBadge,
    BInputGroup,
    BInputGroupAppend,
    BFormInput,

    InfluencerLinkBtn,
    CampaignLinkBtn
  },
  data() {
    return {
      logs: [],
      total: 0,
      currentPage: 1,
      perPage: 25,
      perPageOptions: [10, 25, 50, 100],
      searchQuery: '',
      sortBy: 'created_at',
      isSortDirDesc: true,
      tableColumns: [
        { key: 'id', label: 'ID', sortable: true },
        { key: 'created_at', label: 'Tarih', sortable: true },
        { key: 'manager', label: 'İşlem Sahibi' },
        { key: 'action', label: 'Aksiyon' },
        { key: 'description', label: 'Açıklama' },
        { key: 'link', label: 'Paylaşım' },
        { key: 'influencer', label: 'Fenomen' },
        { key: 'success', label: 'Durum' },
      ],
    }
  },
  methods: {
    // 🔸 Tarih Formatlama
    formatDate(date) {
      if (!date) return '-'
      return new Date(date).toLocaleString('tr-TR', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    },

    // 🔸 Veriyi Getir
    fetchLogs(ctx, callback) {
      this.$http
        .get('/loggers', {
          params: {
            q: this.searchQuery,
            page: this.currentPage,
            perPage: this.perPage,
            sortBy: this.sortBy,
            sortDesc: this.isSortDirDesc ? 'true' : 'false',
          },
        })
        .then(response => {
          const data = response.data.data
          // Backend plain array dönerse
          const logs = Array.isArray(data) ? data : data.items || data.Logs || []
          this.logs = logs
          this.total = data.total || logs.length
          callback(logs)
        })
        .catch(() => {
          callback([])
        })
    },

    // 🔸 Sayfa yenileme
    refetchData() {
      this.$refs.refLoggerTable.refresh()
    },

  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 80px;
}
</style>
